import { Bets } from '../../../config/bets';

import { BlockReason, useBetBlockedStatusConnected } from './useBetBlockedStatusConnected';

export const useAllLimitConnected = (): (string|undefined) => {
  const blockedStatusOne = useBetBlockedStatusConnected(Bets.One);
  const blockedStatusTwo = useBetBlockedStatusConnected(Bets.Two);
  const blockedStatusFive = useBetBlockedStatusConnected(Bets.Five);
  const blockedStatusEight = useBetBlockedStatusConnected(Bets.Eight);
  const blockedStatusTen = useBetBlockedStatusConnected(Bets.Ten);
  const blockedStatusFifteen = useBetBlockedStatusConnected(Bets.Fifteen);
  const blockedStatusTwenty = useBetBlockedStatusConnected(Bets.Twenty);
  const blockedStatusThirty = useBetBlockedStatusConnected(Bets.Thirty);
  const blockedStatusForty = useBetBlockedStatusConnected(Bets.Forty);

  const reasons = [
    blockedStatusOne.reason,
    blockedStatusTwo.reason,
    blockedStatusFive.reason,
    blockedStatusEight.reason,
    blockedStatusTen.reason,
    blockedStatusFifteen.reason,
    blockedStatusTwenty.reason,
    blockedStatusThirty.reason,
    blockedStatusForty.reason,
  ].filter(el => el);

  if (reasons.includes(BlockReason.MinLimit)) {
    return 'MULTIPLE_BET_MIN_LIMIT';
  }
  if (reasons.includes(BlockReason.MaxLimit)) {
    return 'MULTIPLE_BET_MAX_LIMIT';
  }
  if (reasons.includes(BlockReason.LowBalance)) {
    return 'MULTIPLE_BET_LOW_BALANCE';
  }

  return undefined;
};
